class Footer {
    constructor() {
        this.containerId = 'footer-map';
        this.container = null;
        this.map = null;
        this.placemark = null;
        this.apiCheckInterval = null;
        this.maxAttempts = 50;
        this.attempts = 0;

        this.init();
    }

    init() {
        this.bindAccessibilityLinks();
        this.initLinksAccordion();
        this.container = document.getElementById(this.containerId);
        
        if (!this.container) {
            return;
        }

        if (typeof ymaps !== 'undefined') {
            this.createMap();
            return;
        }

        this.waitForApi();
    }

    bindAccessibilityLinks() {
        const accessibilityLinks = document.querySelectorAll('a[href="#VersionVisually"]');
        
        accessibilityLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                
                if (typeof special !== 'undefined' && special && typeof special.On === 'function') {
                    special.On();
                }
            });
        });
    }

    waitForApi() {
        this.apiCheckInterval = setInterval(() => {
            this.attempts++;
            
            if (typeof ymaps !== 'undefined') {
                clearInterval(this.apiCheckInterval);
                this.createMap();
            } else if (this.attempts >= this.maxAttempts) {
                clearInterval(this.apiCheckInterval);
            }
        }, 100);
    }

    initLinksAccordion() {
        const columns = document.querySelectorAll('.footer__links-column');

        if (!columns.length) {
            return;
        }

        const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

        columns.forEach((column) => {
            const title = column.querySelector('.footer__links-title');
            const list = column.querySelector('.footer__links-list');

            if (!title || !list) {
                return;
            }

            const setMaxHeight = (open) => {
                if (!isMobile()) {
                    list.style.maxHeight = '';
                    return;
                }

                if (open) {
                    const fullHeight = list.scrollHeight;
                    list.style.maxHeight = `${fullHeight}px`;
                } else {
                    list.style.maxHeight = '0px';
                }
            };

            title.setAttribute('aria-expanded', 'false');
            setMaxHeight(false);

            const toggle = () => {
                const isOpen = column.classList.contains('footer__links-column--open');

                if (isOpen) {
                    column.classList.remove('footer__links-column--open');
                    title.setAttribute('aria-expanded', 'false');
                    setMaxHeight(false);
                } else {
                    column.classList.add('footer__links-column--open');
                    title.setAttribute('aria-expanded', 'true');
                    setMaxHeight(true);
                }
            };

            title.addEventListener('click', toggle);

            title.addEventListener('keydown', (event) => {
                const { key } = event;

                if (key === 'Enter' || key === ' ') {
                    event.preventDefault();
                    toggle();
                }
            });
        });
    }

    createMap() {
        ymaps.ready(() => {
            if (!this.container) {
                return;
            }

            const defaultCoords = window.footerMapData?.coords || [53.6785, 23.8343];
            const defaultZoom = window.footerMapData?.zoom || 16;

            this.map = new ymaps.Map(this.containerId, {
                center: defaultCoords,
                zoom: defaultZoom,
                controls: []
            });

            this.createPlacemark(defaultCoords);
        });
    }

    createPlacemark(coords) {
        const address = window.footerMapData.address;
        
        this.placemark = new ymaps.Placemark(
            coords,
            {
                balloonContent: address
            },
            {
                preset: 'islands#blueIcon'
            }
        );

        this.map.geoObjects.add(this.placemark);
    }

    destroy() {
        if (this.apiCheckInterval) {
            clearInterval(this.apiCheckInterval);
        }
        
        if (this.map) {
            this.map.destroy();
        }
        
        this.map = null;
        this.placemark = null;
        this.container = null;
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new Footer();
    });
}
